'use client';

import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge } from '@sola/ark-core/atoms/badge/badge.js';
import {
  RadioGroupButtons,
  RadioGroupButtonsItem,
} from '@sola/ark-core/molecules/radio-group-buttons/radio-group-buttons.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { PaymentMethodTypesEnum } from '@sola/schema/dotcom/supporters/paymentMethods.js';
import { IconNames } from '@sola/schema/lib/icons/icon-names.js';

interface PaymentMethodSwitchProps {
  setSelectedPaymentMethod: Dispatch<SetStateAction<PaymentMethodTypesEnum>>;
}

type PaymentMethodButtonProps = {
  value: PaymentMethodTypesEnum;
  iconName: IconNames;
  labelKey: string;
  isPreferred?: boolean;
};

const buttons: PaymentMethodButtonProps[] = [
  {
    value: PaymentMethodTypesEnum.Ach,
    iconName: 'bank',
    labelKey: 'payments.methodTypes.ach.short',
    isPreferred: true,
  },
  {
    value: PaymentMethodTypesEnum.Card,
    iconName: 'credit-card-02',
    labelKey: 'payments.methodTypes.creditCard.short',
  },
];

export const PaymentMethodSwitch = ({
  setSelectedPaymentMethod,
}: PaymentMethodSwitchProps) => {
  const { t } = useTranslation('my');
  return (
    <div>
      <RadioGroupButtons
        defaultValue={PaymentMethodTypesEnum.Ach}
        onChange={setSelectedPaymentMethod}
      >
        {buttons.map((button: PaymentMethodButtonProps) => (
          <RadioGroupButtonsItem
            value={button.value}
            id={button.value}
            key={button.value}
          >
            <div className="flex flex-col gap-snug-md">
              <ArkIcon
                iconName={button.iconName}
                width="1.5rem"
                height="1.5rem"
              />
              <div className="flex gap-snug-lg items-center">
                <span className="label-md label-potent">
                  {t(button.labelKey)}
                </span>

                {button.isPreferred && (
                  <Badge
                    color="positive"
                    label={t('addPaymentMethod.switchLabels.preferred')}
                    size="sm"
                  />
                )}
              </div>
            </div>
          </RadioGroupButtonsItem>
        ))}
      </RadioGroupButtons>
    </div>
  );
};
